/**
 * @file
 * BLOG DETAILS
 * Make the subscribe section on the left side fixed on scroll.
 */
'use strict';

(function ($, Drupal) {
  Drupal.behaviors.Blog = {
    attach: function attach() {
      $(window).on('scroll', function () {
        var section = $('.related-articles-section'),
          elValFromTop = Math.ceil(section.offset().top),
          windowHeight = $(window).height(),
          windowScrollValFromTop = $(window).scrollTop();

        // if the sum of the window height and scroll distance from the top is
        // greater than the target element's distance from the top, it should
        // be in view and the event should fire, otherwise reverse any
        // previously applied methods
        if (windowHeight + windowScrollValFromTop > elValFromTop) {
          $('#blog-detail-sidebar').addClass('remove-sticky');
        } else {
          $('#blog-detail-sidebar').removeClass('remove-sticky');
        }
      });
    }
  };
})(jQuery, Drupal);